const authStyles = (theme) => ({
  page: {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(3),
    background:
      'radial-gradient(circle at top left, rgba(91,108,255,0.16), transparent 34%), radial-gradient(circle at bottom right, rgba(124,107,242,0.12), transparent 30%), #f5f7fb',
  },
  main: {
    width: '100%',
    maxWidth: 420,
  },
  paper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
    borderRadius: 20,
    border: '1px solid #eef2f7',
    boxShadow: '0 16px 40px rgba(15, 23, 42, 0.08)',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    width: 56,
    height: 56,
  },
  title: {
    fontWeight: 700,
    marginTop: theme.spacing(1),
  },
  subtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(1),
    textAlign: 'center',
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: theme.spacing(3),
  },
})

export default authStyles
